var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GlobalTextEditorDisplay',_vm._b({},'GlobalTextEditorDisplay',{ value: _vm.html, loading: false },false))
}
var staticRenderFns = []

export { render, staticRenderFns }